import React from 'react';
import Profile from "../../Profile";
import OrderInfo from "./OrderInfo";
import ProgressBuy from "./ProgrssBuy";
import OrderBundleInfo from "./orderBundleInfo";

const OrderDetails = () => {
    return (
        <div className="order-details-wrapper">
            <Profile/>
            <div className="container order-details-container">
                <OrderInfo/>
                <ProgressBuy/>
                <OrderBundleInfo/>
            </div>
        </div>
    );
};

export default OrderDetails;
